import React, { useEffect, useState } from "react";
import {
  Container,
  TextField,
  Typography,
  Grid,
  Button,
  IconButton,
  Box,
  Paper,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  Divider,
} from "@mui/material";
import {
  Visibility,
  VisibilityOff,
  Google as GoogleIcon,
} from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";
import { useForm, Controller } from "react-hook-form";
import CryptoJS from "crypto-js";
import AtithiLogo from "../../../assets/Atithiseva-Logo-Final-1024x298.png";
import "../../../styles/LoginForm.css";
import { useDispatch, useSelector } from "react-redux";
import {
  loginRequest,
  googleSignInRequest,
  resetLoginFormState,
} from "../actions/authActions";
import {
  DASHBOARD,
  FORGOT_PASSWORD,
  VENDOR_DASHBOARD,
} from "../../../component/common/Routes/AppRoutes";
import TextInputField from "../../../component/ui/FormFields/TextInputField";
import { useSelect } from "@mui/base";
import { CUSTOMER_DASHBOARD } from "../../../component/common/Routes/CustomerRoutes";
import CustomButton from "../../../component/ui/FormFields/Button";
import { toast, ToastContainer } from "react-toastify";
import { requestForToken, auth, googleProvider } from "../../../firebase";
import { signInWithPopup } from "firebase/auth";
import { registerDeviceApi } from "../Effects/AuthEffect";

const SECRET_KEY = "843567893696976453275974432697R634976";
export default function LoginForm() {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);

  const error = useSelector((state) => state.auth.error);
  const accessToken = useSelector((state) => state.auth.accessToken);

  const refreshToken = useSelector((state) => state.auth.refreshToken);

  const loading = useSelector((state) => state?.auth?.loading);

  const success = useSelector((state) => state.auth?.success);

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  // Register Device on Visit (Once only)
  // useEffect(() => {
  //   const registerDeviceOnce = async () => {
  //     // Use a persistent flag to ensure API is called only once per device/browser
  //     const isRegistered = localStorage.getItem("isDeviceRegistered");
  //     if (!isRegistered) {
  //       const fcmToken = await requestForToken();
  //       if (fcmToken) {
  //         let deviceId = localStorage.getItem("deviceId");
  //         if (!deviceId) {
  //           deviceId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  //           localStorage.setItem("deviceId", deviceId);
  //         }

  //         try {
  //           await registerDeviceApi({ deviceId: deviceId, device_token: fcmToken });
  //           localStorage.setItem("isDeviceRegistered", "true");
  //         } catch (error) {
  //           console.error("Device registration failed:", error);
  //         }
  //       }
  //     }
  //   };

  //   registerDeviceOnce();
  // }, []);

  const onSubmit = async (data) => {
    // const fcmToken = await requestForToken();
    const loginData = {
      ...data,
      // deviceToken: fcmToken
    };
    dispatch(loginRequest(loginData));
    localStorage.setItem("userEmail", data.email);
  };

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const firebaseUser = result.user;
      // const fcmToken = await requestForToken();

      const nameParts = firebaseUser.displayName
        ? firebaseUser.displayName.split(" ")
        : ["", ""];
      const firstName = nameParts[0] || "";
      const lastName = nameParts.slice(1).join(" ") || "";

      const googleLoginData = {
        social_id: firebaseUser.uid,
        social_provider: "google",
        email: firebaseUser.email,
        first_name: firstName,
        last_name: lastName,
        // device_token: fcmToken
      };

      dispatch(googleSignInRequest(googleLoginData));
    } catch (error) {
      toast.error("Google Sign-In failed. Please try again.");
    }
  };
  useEffect(() => {
    if (!user) {
      dispatch(resetLoginFormState());
    }
  }, []);
  useEffect(() => {
    localStorage.removeItem("newBookingAccessToken");
    dispatch(resetLoginFormState());
  }, []);

  useEffect(() => {
    if (error) {
      toast.error(error, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resetLoginFormState());
        },
      });
    }
  }, [error]);

  useEffect(() => {
    if (accessToken && refreshToken) {
      const encryptedAccessToken = CryptoJS.AES.encrypt(
        accessToken,
        SECRET_KEY,
      ).toString();
      const encryptedRefreshToken = CryptoJS.AES.encrypt(
        refreshToken,
        SECRET_KEY,
      ).toString();

      sessionStorage.setItem("accessToken", encryptedAccessToken);
      sessionStorage.setItem("refreshToken", encryptedRefreshToken);
      sessionStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("user", Object.keys(user || {}).length);
    }
  }, [user, accessToken, refreshToken, error, navigate]);

  return (
    <>
      <ToastContainer />
      <Box className="login-container">
        <Container maxWidth="sm">
          <Paper className="login-paper" elevation={4}>
            <Box>
              <img
                src={AtithiLogo}
                alt="Atithiseva Logo"
                className="login-logo"
              />
            </Box>
            <Typography variant="h4" className="login-title">
              Login
            </Typography>

            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Controller
                    name="email"
                    control={control}
                    defaultValue=""
                    rules={{
                      required: "Username or Email is required",
                      pattern: {
                        value: /^\S+@\S+\.\S+$/i,
                        message: "Enter a valid email address",
                      },
                    }}
                    render={({ field }) => (
                      <TextInputField
                        {...field}
                        label="Username or Email"
                        placeholder="Enter your username or email"
                        fullWidth
                        autoComplete="new-password"
                        error={!!errors.email}
                        helperText={errors.email?.message}
                        startAdornment={
                          <InputAdornment position="start">
                            <AccountCircleIcon />
                          </InputAdornment>
                        }
                        variant="outlined"
                        className="text-field"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="password"
                    control={control}
                    defaultValue=""
                    rules={{
                      required: "Password is required",
                      minLength: {
                        value: 6,
                        message: "Password must be at least 6 characters",
                      },
                    }}
                    render={({ field }) => (
                      <TextInputField
                        {...field}
                        label="Password"
                        placeholder="Enter your password"
                        type={showPassword ? "text" : "password"}
                        fullWidth
                        autoComplete="new-password"
                        error={!!errors.password}
                        helperText={errors.password?.message}
                        startAdornment={
                          <InputAdornment position="start">
                            <LockIcon />
                          </InputAdornment>
                        }
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword((prev) => !prev)}
                              edge="end"
                            >
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        variant="outlined"
                        className="text-field"
                      />
                    )}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  display="flex"
                  justifyContent="end"
                  alignItems="center"
                >
                  <Link to={FORGOT_PASSWORD} className="forgot-password-link">
                    Forgot Password ?
                  </Link>
                </Grid>

                <Grid item xs={12}>
                  <CustomButton
                    variant="contained"
                    className="success-button"
                    type="submit"
                    fullwidth={true}
                    loading={loading}
                    text={"Login"}
                    onClick={handleSubmit(onSubmit)}
                  />
                </Grid>
                {/* <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    fullWidth
                    startIcon={<GoogleIcon />}
                    onClick={handleGoogleLogin}
                    sx={{
                      py: 1.2,
                      textTransform: "none",
                      color: "text.primary",
                      borderColor: "divider",
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.04)",
                        borderColor: "text.primary",
                      },
                    }}
                  >
                    Sign in with Google
                  </Button>
                </Grid> */}
                <Grid item xs={12}>
                  <Divider sx={{ my: 1 }} />
                  <Box sx={{ textAlign: "center", mt: 1 }}>
                    <Box
                      sx={{ display: "flex", justifyContent: "center", gap: 3 }}
                    >
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        New user ? Sign up as :
                      </Typography>
                      <Link
                        to={"/customer-registration"}
                        style={{
                          color: "#1976d2",
                          textDecoration: "none",
                          marginRight: "-10px",
                        }}
                      >
                        Customer
                      </Link>
                      <Typography
                        variant="body2"
                        sx={{ color: "text.primary" }}
                      >
                        |
                      </Typography>
                      <Link
                        to={"/vendor-registration"}
                        style={{
                          color: "#1976d2",
                          textDecoration: "none",
                          marginLeft: "-10px",
                        }}
                      >
                        Vendor
                      </Link>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Container>
      </Box>
    </>
  );
}
